import { RouteConfig } from '@guiker/router'

const routes: { [key: string]: RouteConfig } = {}

export { routes }
